// extracted by mini-css-extract-plugin
export var arrowDown = "OddsWithChanges-module--arrowDown--476cd";
export var arrowUp = "OddsWithChanges-module--arrowUp--0a3b4";
export var odds = "OddsWithChanges-module--odds--b9f25";